import PropTypes from 'prop-types';
import React from 'react';

import StateLinksCard from './StateLinksCard';

const legregLinks = [
  {
    title: 'Litigation Bulletins',
    href: '/advocacy/legal-judicial-advocacy/litigation-bulletin/[slug]',
  },
  {
    title: 'Legislation and Regulation Database',
    href: `/statenet-redirect/maptrack`,
    as: '/statenet-redirect/[slug]',
    external: true,
  },
  {
    title: 'Proposed Regulation Bulletins',
    href: '/compliance/legislative-regulatory-activity/proposed-regulation-bulletin/[slug]',
  },
  {
    title: 'Legislative Tracking Reports',
    href: '/compliance/legislative-regulatory-activity/legislative-tracking-report/[slug]',
  },
  {
    title: 'Regulatory Tracking Reports',
    href: '/compliance/legislative-regulatory-activity/regulatory-tracking-report/[slug]',
  },
];

function LegRegLinks({ stateCode }) {
  return (
    <StateLinksCard
      category="Legislation & Regulation"
      iconId={27}
      links={legregLinks}
      stateCode={stateCode}
    />
  );
}

LegRegLinks.propTypes = {
  stateCode: PropTypes.string.isRequired,
};

export default LegRegLinks;
